var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 28,
    viewBox: "0 0 512 512",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m95 61h-60c-19.299 0-35 15.701-35 35v60c0 8.284 6.716 15 15 15s15-6.716 15-15v-60c0-2.757 2.243-5 5-5h60c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m95 421h-60c-2.757 0-5-2.243-5-5v-60c0-8.284-6.716-15-15-15s-15 6.716-15 15v60c0 19.299 15.701 35 35 35h60c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m497 341c-8.284 0-15 6.716-15 15v60c0 2.757-2.243 5-5 5h-60c-8.284 0-15 6.716-15 15s6.716 15 15 15h60c19.299 0 35-15.701 35-35v-60c0-8.284-6.716-15-15-15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m477 61h-60c-8.284 0-15 6.716-15 15s6.716 15 15 15h60c2.757 0 5 2.243 5 5v60c0 8.284 6.716 15 15 15s15-6.716 15-15v-60c0-19.299-15.701-35-35-35z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m90 375v-238c0-8.284-6.716-15-15-15s-15 6.716-15 15v238c0 8.284 6.716 15 15 15s15-6.716 15-15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m135 122c-8.284 0-15 6.716-15 15v158c0 8.284 6.716 15 15 15s15-6.716 15-15v-158c0-8.284-6.716-15-15-15z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m195 122c-8.284 0-15 6.716-15 15v238c0 8.284 6.716 15 15 15s15-6.716 15-15v-238c0-8.284-6.716-15-15-15z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m255 122c-8.284 0-15 6.716-15 15v158c0 8.284 6.716 15 15 15s15-6.716 15-15v-158c0-8.284-6.716-15-15-15z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m315 122c-8.284 0-15 6.716-15 15v158c0 8.284 6.716 15 15 15s15-6.716 15-15v-158c0-8.284-6.716-15-15-15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m375 122c-8.284 0-15 6.716-15 15v158c0 8.284 6.716 15 15 15s15-6.716 15-15v-158c0-8.284-6.716-15-15-15z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m450 375v-238c0-8.284-6.716-15-15-15s-15 6.716-15 15v238c0 8.284 6.716 15 15 15s15-6.716 15-15z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m135 343c-8.284 0-15 6.716-15 15v17c0 8.284 6.716 15 15 15s15-6.716 15-15v-17c0-8.284-6.716-15-15-15z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m255 343c-8.284 0-15 6.716-15 15v17c0 8.284 6.716 15 15 15s15-6.716 15-15v-17c0-8.284-6.716-15-15-15z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m315 343c-8.284 0-15 6.716-15 15v17c0 8.284 6.716 15 15 15s15-6.716 15-15v-17c0-8.284-6.716-15-15-15z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m375 343c-8.284 0-15 6.716-15 15v17c0 8.284 6.716 15 15 15s15-6.716 15-15v-17c0-8.284-6.716-15-15-15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.bdfae30afd5670f78f93f05cf946d8a4.svg";
export { ForwardRef as ReactComponent };